import { render, staticRenderFns } from "./LaunchWeApp.vue?vue&type=template&id=402650ca&"
import script from "./LaunchWeApp.vue?vue&type=script&lang=ts&"
export * from "./LaunchWeApp.vue?vue&type=script&lang=ts&"
import style0 from "./LaunchWeApp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports